import { cn } from "@/lib/utils";

import { ButtonExitProps } from "../../types";

const ButtonExit: React.FC<ButtonExitProps> = ({ children, className, ...rest }) => {
    return (
        <button
            className={cn(
                "flex justify-center items-center bg-red-cancel border ButtonExit |",
                "border-[1.5px] border-white",
                "h-[30px] w-[30px] 2xs:h-[45px] 2xs:w-[45px] rounded-[9px] shadow-button-exit-mobile",
                "lg:rounded-[12px]",
                "active:shadow-button-exit-stele-active",
                "4k:w-[240px] 4k:h-[240px] 4k:rounded-[64px] 4k:border-[4px] 4k:shadow-button-exit-stele",
                className,
            )}
            {...rest}
        >
            <div
                className={cn(
                    "relative flex justify-center items-center active:bg-opacity-40",
                    "h-[30px] 2xs:h-[45px] w-[30px] 2xs:w-[45px] rounded-[9px]",
                    "lg:h-[56px] lg:w-[56px] lg:rounded-[12px]",
                )}
            >
                <div
                    className={cn(
                        "absolute flex justify-center items-center",
                        "h-[22px] w-[22px]",
                        "2xs:h-[28px] 2xs:w-[28px]",
                        "lg:h-[28px] lg:w-[28px]",
                        "4k:h-[112px] 4k:w-[112px]"
                    )}
                >
                    {children}
                </div>
            </div>
        </button>
    );
};

export default ButtonExit;
